import React from "react";

import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ChevronRightIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M11.322 25.735a1 1 0 0 1-.057-1.413L18.943 16l-7.678-8.322a1 1 0 1 1 1.47-1.356l7.785 8.437c.64.694.64 1.788 0 2.482l-7.785 8.437a1 1 0 0 1-1.413.057Z" />
  </BaseIcon>
);
